import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../assets/ezgif.com-gif-maker.jpg';
import ParticlesBackground from '../../Components/Particels/ParticlesBackground';
const About = () => {




    return (
        <div>
            <ParticlesBackground></ParticlesBackground>
            <div className="hero min-h-screen bg-base-200 pt-16">
            
                <div className="hero-content flex-col lg:flex-row justify-center">
                    <div className='w-full lg:w-1/2 flex justify-center gap-5 bg-clip-content'>
                        <div className='h-96 bg-cover w-96 bg-sky-500/50 absolute blur'></div>
                        <img src={img1} className=" transition delay-150 duration-300 ease-in-out relative hover:rotate-6 h-96 bg-center bg-cover w-96 rounded-lg  shadow-lg shadow-sky-500/50" />
                    </div>
                    <div className='w-full lg:w-1/2'>
                    <h1 className="text-5xl font-bold">About Monika!</h1>
                    <p className="py-6">Hi! I am Monika Hossan Momi, a Front End Developer.I Have Completed My Bachelor Of Science In Computer Science And Engineering. Designing and Coding have been my passion.I have been working in this sector since 2021. I enjoy creating beautifully designed, intuitive and functional website. My expertise includes Javascript, React, Express, Node.js,Firebase Auth and MongoDB.</p>
                    <button className="btn"><a href="https://github.com/devmonika" target='_blank'>GitHub</a></button>
                    </div>
                </div>
                </div>


    
        </div>
    );
};

export default About;